export const LOADING_TIME = 500; // Loading circle duration in milliseconds.
export const SHOW_MESSAGE_TIME = 10000; // Message duration in milliseconds.
export const TOKEN = {
  EXP_TIME: 5, // Token expiration time in minutes.
  REFRESH_INTERVAL: 3, // Interval for token refresh in minutes.
};
